// import HttpService from "./HttpService";
// export const LoadExamResults = () => {
//   const http = new HttpService();
//   let examresultsUrl = "users/batches";
//   const tokenId = "user-token";
//   return http
//     .getData(examresultsUrl, tokenId)
//     .then((data) => {
//       // console.log(data);
//       return data;
//     })
//     .catch((error) => {
//       // console.log(error);
//       return error;
//     });
// };


import HttpService from "./HttpService";
export const LoadExamResults = (data) => {
  const http = new HttpService();
  // alert(data.id);
  let SinglebatchesUrl = `users/exam_results/${data.id}`;
  const tokenId = "user-token";
  return http
    .getData(SinglebatchesUrl, tokenId)
    .then((data) => {
      // console.log(data);
      return data;
    })
    .catch((error) => {
      console.log(error);
      return error;
    });
};
